module.exports = __webpack_public_path__ + "img/Constellation-Family-Logos-Lockup-760px.f659cbbd.png";